import {
    Component,
    HostBinding,
    Input,
    ChangeDetectionStrategy,
} from '@angular/core';

@Component({
    selector: 'app-handle',
    templateUrl: './handle.component.html',
    styleUrls: ['./handle.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class HandleComponent {
    @Input()
    @HostBinding('class.active')
    public active = false;

    @Input()
    @HostBinding('class.small')
    public small = false;
}
